import { useContext } from 'react';
import Fullstory from '../contexts/fullstory.js';
export default function useFullstory() {
    const fullstory = useContext(Fullstory);
    if (fullstory === null) {
        throw new Error('Expected the Fullstory context to be provided.');
    }
    return fullstory;
}
//# sourceMappingURL=use-fullstory.js.map